import { render, staticRenderFns } from "./PathForward.vue?vue&type=template&id=04b96fe4"
import script from "./PathForward.vue?vue&type=script&lang=js"
export * from "./PathForward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports